import { useMutation } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { AxiosError, AxiosResponse } from "axios";
import { useNavigate } from "react-router";

import { useErrorModal } from "../../error-handling/app-error-modal-provider";
import { useOfferRequestPath } from "../../offers/hooks/use-offer-request-path";

export const useRequestNewOffersMutation = (productRequestId: string, onSuccessCapture?: () => void) => {
  const { openErrorModal } = useErrorModal();
  const client = useAxios();
  const navigate = useNavigate();
  const offerPaths = useOfferRequestPath();

  return useMutation<AxiosResponse<{ success: boolean }>, AxiosError>({
    mutationKey: ["requestNewOffers", productRequestId],
    mutationFn: () => client.post<{ success: boolean }>(offerPaths.requestNewOffers(productRequestId)),
    onSuccess: () => {
      onSuccessCapture?.();
      navigate(offerPaths.viewCustomerRoot());
    },
    onError: (error) => {
      openErrorModal({
        variant: "submit-error",
        error: new Error("Failed to request new offers for customer", { cause: error }),
      });
    },
  });
};
